/* ==========================================================================
   BSC Academy — nastro dei numeri · v3 · 25/08/2026

   v3 (Rami, 25/08). La v2 aveva tre difetti, tutti misurati sul servito
   prima di toccare una riga. Vale la pena tenerli scritti: sono tre modi
   diversi di sbagliare lo stesso oggetto.

   1. IL NASTRO PARTIVA PRIMA DI GSAP, E NON SE NE ACCORGEVA.
      Questo file esce dalla sezione, a meta `<body>`; GSAP esce da
      `theme.liquid`, in fondo. Gli script `defer` girano in ordine di
      documento, quindi qui `window.gsap` era ancora `undefined` (misurato:
      bsc-prova.js e lo script 11, gsap.min.js il 16). La guardia
      «se GSAP c'e aspetto i contatori» leggeva `false` e faceva partire
      tutto subito. Ora si entra da `WS_GSAP.ready()`, che e la porta
      ufficiale del loader: si apre quando core e plugin sono registrati,
      mai prima. → snippets/bsc-gsap.liquid

   2. IL CONTATORE NON PUO STARE IN UN NASTRO. Non e un bug da aggiustare,
      e un'incompatibilita: in fascia la stessa fila e in scena in tre copie,
      ma `data-conta` sta su una sola. Le altre due mostravano gia il numero
      vero mentre l'originale saliva da zero — a destra i numeri definitivi
      dal primo fotogramma, a sinistra tre caselle vuote che si riempivano a
      1,3s, 2,5s e 3,3s. Il contatore adesso vive solo nella modalita a
      griglia: nel nastro il Liquid non scrive proprio gli attributi, e
      questo file non ha piu niente da aspettare. → sections/bsc-prova.liquid

   3. LE @KEYFRAMES SI RIAVVIAVANO DA SOLE. Lo spostamento stava in una
      variabile CSS, e quella variabile cambia — coi font che caricano, con
      la finestra che si ridimensiona (misurato: 955px al primo fotogramma,
      905px mezzo secondo dopo). Ogni riscrittura faceva ripartire
      l'animazione da capo, ed era lo scatto che si vedeva all'inizio.
      Qui il movimento e UN NUMERO mandato avanti a ogni tick e riavvolto sul
      passo. Il passo puo cambiare quando vuole: si riavvolge sul valore
      nuovo al fotogramma dopo e non si vede niente.

   IL CURSORE. Scelta di Rami del 25/08: la fascia reagisce al puntatore, non
   allo scroll. Due cose insieme, che sono la stessa cosa detta due volte —
   «qui ti stai fermando a guardare»:
     · il nastro RALLENTA (al 12% della sua velocita, in poco piu di mezzo
       secondo, e riprende quando esci);
     · le voci vicine SI SCOSTANO, chi a sinistra verso sinistra e chi a
       destra verso destra, aprendosi attorno a quella sotto il dito — che
       resta ferma e cresce di un filo, e fa da perno. La portata si ricava
       dalla larghezza vera delle voci, non da un numero scritto a mano.
   IL DITO. Su telefono il cursore non esiste, e «resta la deriva» sarebbe
   stato un modo gentile per dire che meta del pubblico non tocca niente.
   Li l'equivalente non e il passaggio, e la PRESA: la fascia si trascina col
   dito e alla lasciata conserva lo slancio, che si spegne rientrando nella
   deriva. E lo stesso patto del cursore — «questa cosa risponde» — detto
   nella lingua del telefono.

   ⚠️ `touch-action: pan-y pinch-zoom` sulla fascia (→ bsc-prova.css) e la
   riga che fa convivere le due cose: lo scorrimento verticale della pagina
   resta al browser, l'orizzontale arriva qui. Senza, o la pagina non scorre
   piu sopra la fascia, o il trascinamento non parte mai.

   Senza GSAP non succede niente e la fila resta ferma e leggibile: lo stato
   lo scrive il JS, mai il CSS. → playbook §9.3
   ========================================================================== */
(function () {
  'use strict';

  /* ---- le manopole -------------------------------------------------------
     ⚠️ IL RAGGIO NON PUO ESSERE UN NUMERO FISSO. Dipende da quanto sono larghe
     le voci, e quelle le scrive il proprietario: «12 percorsi online, altri in
     arrivo» misura 380px, «+500 storie vere» molto meno. Con 300px fissi il
     cursore ne raggiungeva UNA per volta — misurato: 1 voce scostata su 9 — e
     una voce sola che si sposta non e un campo, e un inciampo. Si ricava dal
     passo vero: circa due voci per lato. */
  var LARGHEZZA  = 1.9;   // raggio della spinta, in numero di voci
  var VICINANZA  = 0.62;  // raggio dell'ingrandimento, in numero di voci
  var SPINTA     = 26;    // px — quanto si scosta la voce piu spinta
  var CRESCITA   = 0.07;  // quanto ingrandisce, in frazione
  var MORBIDEZZA = 0.14;  // 0-1: quanto insegue per fotogramma. Alto = secco
  var LENTO      = 0.12;  // moltiplicatore di velocita col cursore sopra
  var COLMO      = 6.75;  // 27/4: riporta a 1 il massimo di u·(1−|u|)²

  function init(nastro) {
    if (!nastro || nastro.dataset.bscMqInit) { return; }

    var pista = nastro.querySelector('[data-bsc-pista]');
    var fila  = pista && pista.firstElementChild;
    var g     = window.gsap;
    if (!pista || !fila || !g) { return; }

    nastro.dataset.bscMqInit = '1';

    var velocita = parseFloat(nastro.dataset.velocita) || 40;   // px al secondo

    var voci = [];        // ogni <li> in pista, copie comprese
    var centri = [];      // centro di ogni voce nello spazio della pista
    var spinta = [];      // scostamento attuale, in px
    var scala = [];       // ingrandimento attuale, in frazione

    var passo = 0;        // larghezza di UNA copia piu il gap
    var raggio = 320;     // portata della spinta, ricavata dal passo
    var raggioVicino = 160;  // portata dell'ingrandimento
    var riposo = 0;       // bordo sinistro della pista senza spostamento
    var x = 0;            // il nastro, tutto qui: un numero
    var puntatore = null; // clientX del cursore, null se fuori
    var vivo = false;     // c'e ancora qualcosa da interpolare?
    var stato = { mult: 1 };
    var presa = null;     // il dito che sta trascinando, null se nessuno
    var slancio = 0;      // px/s residui dopo la lasciata

    function gap() { return parseFloat(getComputedStyle(pista).columnGap) || 0; }

    /* la copia e per gli occhi soltanto: si toglie ogni aggancio, cosi
       nessuno la conta due volte e gli screen reader non la leggono */
    function copia() {
      var c = fila.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-conta');
      c.removeAttribute('data-bsc-init');
      var cifre = c.querySelectorAll('[data-numero]');
      for (var i = 0; i < cifre.length; i++) { cifre[i].removeAttribute('data-numero'); }
      return c;
    }

    /* Un marquee scorre sempre, anche quando il contenuto ci starebbe: le
       voci escono a sinistra e devono rientrare da destra. Perche non si veda
       mai il fondo vuoto la pista deve essere larga il contenitore PIU un
       passo — con tre numeri corti su uno schermo largo servono quattro
       copie, con otto numeri ne bastano due. Si conta, non si indovina. */
    function quante() {
      var p = fila.getBoundingClientRect().width + gap();
      if (!(p > 0)) { return 2; }
      return Math.max(2, Math.ceil(nastro.clientWidth / p) + 1);
    }

    function avvolgi(v) {
      if (!(passo > 0)) { return v; }
      v = v % passo;
      return v > 0 ? v - passo : v;     // sempre dentro (-passo, 0]
    }

    /* ⚠️ Si misura con le spinte AZZERATE. Leggendo le voci mentre il cursore
       le tiene scostate, la posizione «a riposo» verrebbe registrata gia
       spostata, e a ogni ridimensionamento la fila scivolerebbe di qualche
       pixel senza motivo apparente. */
    function misura() {
      var servono = quante();
      while (pista.children.length < servono) { pista.appendChild(copia()); }
      while (pista.children.length > servono && pista.children.length > 2) {
        pista.removeChild(pista.lastElementChild);
      }

      voci = [].slice.call(pista.querySelectorAll('.bsc-prova__dato'));
      g.set(voci, { x: 0, scale: 1 });

      passo = fila.getBoundingClientRect().width + gap();

      /* il passo diviso le voci di UNA fila da il passo medio di una voce:
         e la sola misura che sa quanto e larga la scrittura del proprietario */
      var largo = passo / Math.max(1, fila.children.length);
      raggio = Math.max(320, largo * LARGHEZZA);
      raggioVicino = Math.max(140, largo * VICINANZA);

      /* `base` contiene lo spostamento corrente: sottraendolo si ottiene il
         bordo a riposo, e i centri restano nello spazio della pista — cosi
         non vanno rimisurati a ogni fotogramma. */
      var base = pista.getBoundingClientRect().left;
      riposo = base - x;

      centri.length = spinta.length = scala.length = 0;
      for (var i = 0; i < voci.length; i++) {
        var r = voci[i].getBoundingClientRect();
        centri[i] = r.left + r.width / 2 - base;
        spinta[i] = 0;
        scala[i] = 0;
      }

      x = avvolgi(x);
      g.set(pista, { x: x });
    }

    function frame(_t, dt) {
      /* dopo una scheda lasciata in secondo piano il delta vale secondi:
         senza tetto il nastro si teletrasporterebbe */
      if (dt > 60) { dt = 60; }

      /* mentre il dito comanda, la deriva tace: due mani sullo stesso numero
         si combattono, e si vede come un tremolio sotto il dito */
      if (!(presa && presa.asse === 'x')) {
        x = avvolgi(x - velocita * stato.mult * (dt / 1000) + slancio * (dt / 1000));
        /* decadimento agganciato al tempo, non ai fotogrammi: a 120Hz uno
           slancio non deve spegnersi in meta strada rispetto a 60Hz */
        slancio *= Math.pow(0.94, dt / 16.667);
        if (slancio < 2 && slancio > -2) { slancio = 0; }
      }
      g.set(pista, { x: x });

      if (puntatore === null && !vivo) { return; }

      var origine = riposo + x;
      var residuo = 0;

      for (var i = 0; i < voci.length; i++) {
        var bSpinta = 0, bScala = 0;

        if (puntatore !== null) {
          var d = origine + centri[i] - puntatore;

          /* ⚠️ LA SPINTA VALE ZERO SOTTO IL DITO, non il massimo.
             Con la forza al centro e il verso preso dal segno di `d`, una voce
             attraversata dal cursore saltava da +26px a −26px in un fotogramma:
             la spinta e continua, il segno no. Qui la curva e u·(1−|u|)², che
             nasce a zero al centro, culmina a un terzo del raggio e si spegne
             al bordo — cosi la voce sotto il cursore fa da perno e le altre le
             si aprono intorno. Che poi e quello che vuol dire «si distanziano». */
          var u = d / raggio;
          var au = u < 0 ? -u : u;
          if (au < 1) { bSpinta = SPINTA * COLMO * u * (1 - au) * (1 - au); }

          /* l'ingrandimento invece si, e massimo al centro: e il perno */
          var q = 1 - Math.min(1, (d < 0 ? -d : d) / raggioVicino);
          if (q > 0) { bScala = CRESCITA * q * q * (3 - 2 * q); }
        }

        spinta[i] += (bSpinta - spinta[i]) * MORBIDEZZA;
        scala[i]  += (bScala  - scala[i])  * MORBIDEZZA;
        residuo += Math.abs(spinta[i]);

        g.set(voci[i], { x: spinta[i], scale: 1 + scala[i] });
      }

      /* sotto questa soglia il ritorno a posto e finito: si smette di
         scrivere transform su ogni voce a ogni fotogramma */
      vivo = residuo > 0.05;
    }

    /* ---- il cursore ------------------------------------------------------
       Solo dove un cursore esiste davvero: `hover: hover` da solo dice si
       anche su certi tablet con la penna, dove `pointerleave` non arriva mai
       e la fascia resterebbe lenta per sempre. */
    /* ⚠️ Si guarda `pointerType` a ogni evento, non solo il media query.
       Su un portatile touch `(hover: hover) and (pointer: fine)` dice si — c'e
       il trackpad — ma sullo schermo si tocca lo stesso, e un tocco fa partire
       `pointerenter`. Senza questo controllo un dito avvierebbe il ramo del
       cursore, e `pointerleave` non arriverebbe mai: fascia lenta per sempre. */
    function entra(e) {
      if (e.pointerType !== 'mouse') { return; }
      puntatore = e.clientX;
      vivo = true;
      g.to(stato, { mult: LENTO, duration: 0.55, ease: 'power2.out', overwrite: true });
    }
    function muove(e) {
      if (e.pointerType !== 'mouse') { return; }
      puntatore = e.clientX;
    }
    function esce(e) {
      if (e && e.pointerType !== 'mouse') { return; }
      puntatore = null;
      /* si riprende piu lentamente di come si e fermata: rallentare e una
         reazione, ripartire e tornare alla normalita */
      g.to(stato, { mult: 1, duration: 0.9, ease: 'power2.inOut', overwrite: true });
    }

    /* ---- il dito ---------------------------------------------------------
       L'asse si decide al primo movimento vero e poi NON si cambia piu. Senza
       questo blocco un pollice che scende in diagonale sposta la fascia di
       traverso e la pagina a scatti: chi scorre un sito col pollice non fa mai
       una riga dritta, e il gesto va interpretato una volta sola. */
    function giu(e) {
      if (e.pointerType === 'mouse') { return; }
      presa = { id: e.pointerId, x0: e.clientX, y0: e.clientY,
                ultimo: e.clientX, quando: e.timeStamp, asse: null, v: 0 };
      slancio = 0;
    }

    function tira(e) {
      if (!presa || e.pointerId !== presa.id) { return; }

      var dx = e.clientX - presa.x0;
      var dy = e.clientY - presa.y0;

      if (presa.asse === null) {
        /* 6px di soglia: sotto, e un tocco fermo, non un gesto */
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) { return; }
        presa.asse = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        /* la presa segue il dito anche fuori dalla fascia: alzandolo altrove
           `pointerup` arriva lo stesso e lo slancio non resta appeso */
        if (presa.asse === 'x' && nastro.setPointerCapture) {
          try { nastro.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      if (presa.asse !== 'x') { return; }   // verticale: scorre la pagina

      var scatto = e.clientX - presa.ultimo;
      x = avvolgi(x + scatto);
      g.set(pista, { x: x });

      var quanto = e.timeStamp - presa.quando;
      if (quanto > 0) { presa.v = scatto / quanto * 1000; }   // px al secondo
      presa.ultimo = e.clientX;
      presa.quando = e.timeStamp;
    }

    function molla(e) {
      if (!presa || e.pointerId !== presa.id) { return; }
      if (presa.asse === 'x') {
        /* il tetto e sui 2600px/s: oltre, una sventagliata manderebbe la
           fascia in un giro cieco e si perderebbe il filo dei numeri */
        slancio = Math.max(-2600, Math.min(2600, presa.v));
      }
      presa = null;
    }

    nastro.addEventListener('pointerenter', entra);
    nastro.addEventListener('pointermove', muove);
    nastro.addEventListener('pointerleave', esce);
    nastro.addEventListener('pointerdown', giu);
    nastro.addEventListener('pointermove', tira);
    nastro.addEventListener('pointerup', molla);
    nastro.addEventListener('pointercancel', molla);

    /* ---- rimisure --------------------------------------------------------
       Il passo cambia con la larghezza e con i font che arrivano. Adesso
       cambiarlo non costa niente: il numero si riavvolge sul valore nuovo. */
    var attesa;
    function ripensa() { clearTimeout(attesa); attesa = setTimeout(misura, 160); }

    var ro = window.ResizeObserver ? new ResizeObserver(ripensa) : null;
    if (ro) { ro.observe(nastro); } else { window.addEventListener('resize', ripensa); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(misura).catch(function () {}); }

    misura();
    g.ticker.add(frame);

    /* smontaggio: nel theme editor la sezione viene ricostruita a ogni
       modifica, e un tick agganciato a nodi non piu nel DOM resta a girare */
    nastro._bscMqSpegni = function () {
      g.ticker.remove(frame);
      clearTimeout(attesa);
      if (ro) { ro.disconnect(); } else { window.removeEventListener('resize', ripensa); }
      nastro.removeEventListener('pointerenter', entra);
      nastro.removeEventListener('pointermove', muove);
      nastro.removeEventListener('pointerleave', esce);
      nastro.removeEventListener('pointerdown', giu);
      nastro.removeEventListener('pointermove', tira);
      nastro.removeEventListener('pointerup', molla);
      nastro.removeEventListener('pointercancel', molla);
      delete nastro.dataset.bscMqInit;
    };
  }

  function tutte(scope) {
    var n = (scope || document).querySelectorAll('[data-bsc-marquee]');
    for (var i = 0; i < n.length; i++) { init(n[i]); }
  }

  /* La porta ufficiale del loader: si apre a core e plugin registrati. Il
     ramo `load` e per il caso in cui lo stub non ci sia — non deve succedere,
     ma se succede la fascia parte lo stesso invece di restare ferma. */
  (window.WS_GSAP ? WS_GSAP.ready : function (f) { window.addEventListener('load', f); })(function () {
    tutte(document);
  });

  document.addEventListener('shopify:section:load', function (e) { tutte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var n = e.target.querySelectorAll('[data-bsc-marquee]');
    for (var i = 0; i < n.length; i++) {
      if (n[i]._bscMqSpegni) { n[i]._bscMqSpegni(); }
    }
  });
})();
